<!-- <app-menu></app-menu> -->
<div  class="page_header mt-20">
	<h6 *ngIf="!isEd" class="heading"><center>Account Number :{{carrierAccNumber}}| Account Name :{{carrierNames}} |Carrier Type:{{carrierType}}</center></h6>
  </div>
  <br>
<button (click)="jumpToOCAS()" id="jumpToOcasID" style="display: none;"></button>
<div class="stepper_wrapper">
	<div class="stepper_box">
	  <div class="sticky">
		<div class="step_row">
		  <div class="step step-one" id="jumpToInfo" (click)="jumpToInfo()">
			1. Carrier Information
		  </div>
		  <div class="circle" [style.background-color]="background1">
			<img
			  src="../../assets/stepper-img/done-56@2x.png"
			  *ngIf="!isProgress1"
			  height="10"
			/>
			<span style="color: transparent" *ngIf="isProgress1">1</span>
		  </div>
		  <div></div>
		</div>
		<div class="step_row">
		  <div class="step step-two" id="jumpToDoc" (click)="jumpToDoc()">
			2. Supporting Document
		  </div>
		  <div class="circle" [style.background-color]="background2">
			<img
			  src="../../assets/stepper-img/done-56@2x.png"
			  *ngIf="isProgress2"
			  height="10"
			/>
			<span style="color: transparent" *ngIf="!isProgress2">2</span>
		  </div>
		  <div></div>
		</div>
		<div class="step_row">
		  <div class="step step-three" (click)="jumpToOCAS()" id="jumpToOcas">3. OCAS</div>
		  <div class="circle" [style.background-color]="background3">
			<img
			  src="../../assets/stepper-img/done-56@2x.png"
			  *ngIf="isProgress3"
			  height="10"
			/>
			<span style="color: transparent" *ngIf="!isProgress3">3</span>
		  </div>
		  <div></div>
		</div>
		<div class="step_row">
		  <div class="step step-four" (click)="jumpToReview()">4. Review</div>
		  <div class="circle last" [style.background-color]="background4">
			<img
			  src="../../assets/stepper-img/done-56@2x.png"
			  *ngIf="isProgress4"
			  height="10"
			/>
			<span style="color: transparent" *ngIf="!isProgress4">4</span>
		  </div>
		  <div></div>
		</div>
	  </div>
	</div>
  
	<div class="stepper-content">
	  <div *ngIf="isProgress1">
		<companydetails
		  #company
		  (switchOCAS)="checkOCAS($event)"
		  (nextStep)="next($event)"
		  (carrierIDOutput)="saveCarrierID($event)"
		></companydetails>
		<button
		  type="button"
		  class="btn btn-secondary btn-sm"
		  (click)="next(1)"
		  id="stepperNextBtn1"
		  style="display: none"
		>
		  Next
		</button>
	  </div>
  
	  <div *ngIf="isStepper2">
		<uploaddocument></uploaddocument>
		<!-- <div class="col-12" *ngIf="utility.isBtnVisible">
			<button  title="Save & Continueto step 3" type="submit" id="btnSave" (click)="nextFrame()" class="btn btn-md m-clr pull-right hd-btn" style="width:auto; margin-right:10px;margin-bottom:5px;  ">Save & Continue</button>
			<button *ngIf="utility.isView" title="Previous tab" (click)="back()" type="submit" id="btnSave" class="btn btn-md m-clr pull-left hd-btn" style="width:auto; margin-right:4px;margin-bottom:5px;  ">Back</button>
			<button *ngIf="utility.isView" title="Cancel" (click)="utility.landingPage()" type="submit" id="btnSave" class="btn btn-md m-clr pull-right hd-btn" style="width:auto; margin-right:4px;margin-bottom:5px;  ">Cancel</button>
		  </div> -->
		<div class="col-12 no-mp action_buttons_wrapper">
		  <button type="button" class="btn hd-btn-close" (click)="landing()">
			Close
		  </button>
		  <button
			type="button"
			class="btn hd-btn"
			id="stepperPrevBtn2"
			(click)="previous(2)"
		  >
			Back
		  </button>
		  <button
			type="button"
			class="btn hd-btn"
			id="stepperNxtBtn2"
			(click)="next(2)"
		  >
			Next
		  </button>
		</div>
	  </div>
  
	  <div *ngIf="isStepper3">
		<p>Monthly compliance submissions (Consignment Notes and Passenger Lists) are compulsory for all cross-border operators.  Operators who wish to obtain a higher level of OCAS accreditation have the option to also upload Management System Information to allow their operations to be continuously assessed by the C-BRTA.</p>
		<br>
		<ng-container >
		  <ul class="nav nav-tabs">

			<li class="nav-item" (click)="onDepot()">
			  <a
				class="nav-link active"
				id="depotLink"
				
				
				>Depots</a
			  >
			</li>
			<li class="nav-item" (click)="onDrivers()">
			  <a
				class="nav-link"
				id="driverLink"
				
				>Drivers</a
			  >
			</li>
			<li class="nav-item" (click)="onVehicles()">
			  <a
				class="nav-link"
				id="vehicleLink"
				>Vehicles</a
			  >
			</li>
			<li class="nav-item" (click)="onPrevNextQ()">
				<a
				  class="nav-link "
				  id="questionnaireLink"							  
				  >Questionnaire</a
				>
			  </li>
		  </ul>
  
		  <div class="tab-content">
			
			<div id="depots" class="tab-pane fade active show">
				<app-carrier-depot-list
				(prevNext)="onPrevNextDepot($event)"
			  ></app-carrier-depot-list>
			</div>
			<div id="drivers" class="tab-pane fade">
			  <app-carrier-driver-list
				(prevNext)="onPrevNextDriver($event)"
			  ></app-carrier-driver-list>
			</div>
			<div id="vehicles" class="tab-pane fade">
			  <!-- <app-carrier-driver-list></app-carrier-driver-list> -->
			  <app-manage-vehicles [isInStepper]="true"  [stepperCarrierId]="this.utility.ctrlPages[this.utility.acc.First].carrierId" style="width: 1200px;" *ngIf="this._ocas.stage == 'vehicle'"></app-manage-vehicles>
			</div>
			<div id="questionnaires" class="tab-pane fade ">
				<app-questionnaire
				  [carrierIDInput]="carrierIdForQuestionnaire"
				  (saved)="onSaveQuestionnaire($event)"
				></app-questionnaire>

			  </div>
		  </div>
		</ng-container>
  
		<div class="col-12 no-mp action_buttons_wrapper">
		  <button type="button" class="btn hd-btn-close" (click)="landing()">
			Close
		  </button>
		  <button
			type="button"
			class="btn hd-btn"
			id="stepperPrevBtn3"
			(click)="previous(3)"
		  >
			Back
		  </button>
		  <button
			type="button"
			class="btn hd-btn"
			id="stepperNxtBtn3"
			(click)="next(3)"
		  >
			Next
		  </button>
		</div>
	  </div>
  
	  <div *ngIf="isStepper4">
		<submission [ctrlData]="ctrlData"></submission>
  
		<button
		  type="button"
		  class="btn btn-primary btn-sm"
		  (click)="previous(4)"
		  id="stepperNextBtn4"
		  style="display: none"
		>
		  Prev
		</button>
		<!-- <button type="button" class="btn btn-secondary btn-sm" (click)="next(3)">Done</button> -->
	  </div>
	</div>
  </div>
  
  <!-- <app-stepper-container [isAllowedToNavigate]=true>
  
	<app-stepper title="1. Carrier Information" isProgress='{{isCarrierInProgress}}'>
	  <companydetails #company></companydetails>
	  <button type="button" class="btn btn-secondary btn-sm" (click)="next(1)"  id="stepperNextBtn1" style="display: none;">Next</button>
	</app-stepper>
  
	<app-stepper title="2. Supporting Document" >
	  <uploaddocument></uploaddocument>
	  <div class="col-12 no-mp">
		<button type="button" class="btn hd-btn-close" (click)="previous(2)" >Back</button>
		<button type="button" class="btn hd-btn" (click)="next(2)">Next</button>
		</div>
	</app-stepper>
  
	<app-stepper title="3. Review">
	  <submission [ctrlData]="ctrlData"></submission>
	</app-stepper>
  
  </app-stepper-container> -->
  